import { ArrowIcon, EASE, MediaSlot, useFade, useKnockoutLogo } from "../about/ui";

export { ArrowIcon, EASE, MediaSlot, useFade, useKnockoutLogo };

export function CornerMarks({ dark = false }) {
  return (
    <div className="pointer-events-none absolute inset-0" aria-hidden="true">
      <span className="absolute -left-2.5 -top-2.5 h-14 w-14 border-l-[3px] border-t-[3px] border-verify-gold" />
      <span
        className={`absolute -right-2 -top-2 h-10 w-10 border-r border-t ${dark ? "border-white/20" : "border-navy/20"}`}
      />
      <span
        className={`absolute -bottom-2 -left-2 h-10 w-10 border-b border-l ${dark ? "border-white/20" : "border-navy/20"}`}
      />
      <span className="absolute -bottom-2.5 -right-2.5 h-14 w-14 border-b-[3px] border-r-[3px] border-verify-cyan" />
    </div>
  );
}

export function BrandMark({ src, alt, className }) {
  const { href, failed } = useKnockoutLogo(src);
  const display = !failed && href ? href : src;

  if (!display) {
    return alt ? <span className="text-xs font-semibold tracking-tight text-navy">{alt}</span> : null;
  }

  return <img src={display} alt={alt} className={`object-contain object-center ${className}`} />;
}

export function Field({ label, name, value, onChange, type = "text", required = false, autoComplete }) {
  return (
    <div>
      <label
        htmlFor={name}
        className="block text-[11px] font-semibold uppercase tracking-[0.18em] text-navy/40"
      >
        {label}
        {required ? <span className="text-verify-royal"> *</span> : null}
      </label>
      <input
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        required={required}
        autoComplete={autoComplete}
        className="mt-2 min-h-12 w-full border border-navy/15 bg-white px-4 text-sm text-navy outline-none transition placeholder:text-navy/30 focus:border-verify-gold focus:ring-2 focus:ring-verify-gold/40"
      />
    </div>
  );
}

export function SectionShell({ id, labelledBy, tone = "white", children }) {
  const tones = {
    white: "bg-white text-navy",
    ice: "bg-[#eef3fb] text-navy",
    royal: "bg-verify-royal text-white",
    navy: "bg-navy text-white",
  };

  return (
    <section
      id={id}
      data-tone={tone}
      className={`relative scroll-mt-32 overflow-hidden ${tones[tone] || tones.white}`}
      aria-labelledby={labelledBy}
    >
      <SectionWash tone={tone} />
      {children}
    </section>
  );
}

export function SectionWash({ tone = "white" }) {
  const gold = "rgba(255,191,24,0.18)";
  const cyan = "rgba(34,211,238,0.16)";
  const dark = tone === "royal" || tone === "navy";

  return (
    <div className="pointer-events-none absolute inset-0" aria-hidden="true">
      <div
        className="absolute inset-0"
        style={{
          background: dark
            ? `radial-gradient(70% 50% at 0% 0%, ${gold}, transparent 55%), radial-gradient(55% 40% at 100% 100%, ${cyan}, transparent 50%)`
            : `radial-gradient(70% 50% at 0% 0%, ${gold}, transparent 55%), radial-gradient(55% 40% at 100% 8%, ${cyan}, transparent 50%)`,
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          opacity: dark ? 0.18 : 0.28,
          backgroundImage: dark
            ? "radial-gradient(rgba(255,255,255,0.16) 1px, transparent 1px)"
            : "radial-gradient(rgba(16,14,52,0.07) 1px, transparent 1px)",
          backgroundSize: "26px 26px",
        }}
      />
    </div>
  );
}
